import React from 'react';
import { IIcon } from './types';
import RightChevron from './right-chevron';

const SVG = (props: IIcon & { rotate?: number }) => <RightChevron rotate={180} {...props} />;

export default SVG;
